module.exports = __webpack_public_path__ + "img/bg2.5531cc21.png";